// src/components/PurchaseDetailsModal.js
import React from 'react';
import { formatDate } from '../utils/formatDate';
import './PurchaseFormModal.css'; // Używamy tego samego CSS dla spójności
import { API_URL } from "../config";

function PurchaseDetailsModal({ purchase, onClose, onUpdateStatus, onDelete, currentUser }) {
    const canManage = ['Logistyk', 'Szef', 'Manager'].includes(currentUser.position) || currentUser.role === 'Admin';

    const handleStatusChange = async (newStatus) => {
        try {
            const response = await fetch(`${API_URL}/purchases/${purchase.id}/status`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ status: newStatus }),
            });
            if (!response.ok) throw new Error('Błąd aktualizacji statusu.');
            const updatedPurchase = await response.json();
            onUpdateStatus(updatedPurchase);
        } catch (error) {
            console.error('Błąd:', error);
            alert('Wystąpił błąd podczas zmiany statusu.');
        }
    };

    const handleDelete = async () => {
        if (window.confirm('Czy na pewno chcesz usunąć to zamówienie?')) {
            try {
                const response = await fetch(`${API_URL}/purchases/${purchase.id}/delete`, {
                    method: 'PUT',
                    credentials: 'include',
                });
                if (!response.ok) throw new Error('Błąd usuwania zamówienia.');
                onDelete(purchase.id);
                onClose();
            } catch (error) {
                console.error('Błąd:', error);
                alert('Wystąpił błąd podczas usuwania zamówienia.');
            }
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <h3>Szczegóły Zamówienia #{purchase.nr_zamowienia}</h3>
                <p><strong>Nr. Zlecenia:</strong> {purchase.nr_ref}</p>
                <p><strong>Tytuł Zlecenia:</strong> {purchase.tytul_zlecenia}</p>
                <p><strong>Tytuł Zamówienia:</strong> {purchase.tytul_zamowienia}</p>
                <p><strong>Opis Zamówienia:</strong> {purchase.opis_zamowienia}</p>
                <p><strong>Cena:</strong> {purchase.cena ? `${purchase.cena} zł` : '-'}</p>
                <p><strong>Osoba Zamawiająca:</strong> {purchase.first_name} {purchase.last_name}</p>
                <p><strong>Data Zamówienia:</strong> {formatDate(purchase.data_utworzenia)}</p>
                <p><strong>Termin Realizacji:</strong> {formatDate(purchase.termin_realizacji)}</p>
                <p><strong>Status:</strong> {purchase.status}</p>
                <p><strong>Data Realizacji Zamówienia:</strong> {purchase.data_realizacji_zamówienia ? formatDate(purchase.data_realizacji_zamówienia) : '-'}</p>
                <p><strong>Data Odbioru:</strong> {purchase.data_odbioru ? formatDate(purchase.data_odbioru) : '-'}</p>
                <div className="modal-buttons">
                    {canManage && purchase.stan_zamówienia && (
                        <>
                            <button className="btn-danger" onClick={handleDelete}>
                                Usuń Zamówienie
                            </button>
                            {purchase.status === 'Oczekujące' && (
                                <button className="btn-primary" onClick={() => handleStatusChange('Przyjęte')}>
                                    Przyjmij Zamówienie
                                </button>
                            )}
                            {purchase.status === 'Przyjęte' && (
                                <button className="btn-primary" onClick={() => handleStatusChange('Zamówiono')}>
                                    Zamówiono
                                </button>
                            )}
                            {purchase.status === 'Zamówiono' && (
                                <button className="btn-primary" onClick={() => handleStatusChange('Do odbioru')}>
                                    Gotowe do Odbioru
                                </button>
                            )}
                            {purchase.status === 'Do odbioru' && (
                                <button className="btn-primary" onClick={() => handleStatusChange('Dostarczono')}>
                                    Doręczono
                                </button>
                            )}
                        </>
                    )}
                    <button className="btn-secondary" onClick={onClose}>
                        Zamknij
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PurchaseDetailsModal;